(function ($) {
    $.fn.stickyTable = function () {
        var $fixed;
        this.each(function () {
            var $this = $(this);
            $("body").find(".stickyTable").remove();

            function init() {
                $fixed = $this.clone();
                $fixed.find("tbody").remove().end().addClass("stickyTable").insertBefore($this);
                resizeFixed();
                setFixedCellsPosition();
            }

            function resizeFixed() {
                $fixed.find("th").each(function (index) { $(this).css({ "width": $this.find("th").eq(index).outerWidth() + "px" }); });
                setFixedCellsPosition();
            }

            function setFixedCellsPosition() {
                $fixed.css({ "width": $this.outerWidth(true) });
                var windowScrollLeftIndent = $(window).scrollLeft();
                var gridScrollLeftIndent = $(".resultsGridWrap").scrollLeft();
                var scrollLeftIndent = Math.max(windowScrollLeftIndent, gridScrollLeftIndent);
                $fixed.css({ "width": $this.outerWidth(true), "left": -scrollLeftIndent });
            }

            function scrollFixed() {
                var offset = $(this).scrollTop();
                var tableOffsetTop = $this.offset().top;
                var tableOffsetBottom = tableOffsetTop + $this.height() - $this.find("thead").height();
                if (offset < tableOffsetTop || offset > tableOffsetBottom) $fixed.hide();
                else if (offset >= tableOffsetTop && offset <= tableOffsetBottom && $fixed.is(":hidden")) $fixed.show();

                setFixedCellsPosition();
            }

            $(window).resize(resizeFixed);
            $(window).scroll(scrollFixed);
            $(".resultsGridWrap").scroll(function () {
                $(window).trigger("scroll").trigger("resize");
            });
            init();
        });
        return $fixed;
    };
})(jQuery);